<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div v-show="action ==='list'" class="main-content">
        <search-item
          ref="searchItem"
          config-module="3400"
          :reset="true"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="addHandler"
            >{{ this.$t('CargoMsg.Cargo_NewTo') }}
            </el-button>
            <el-button
              type="primary"
              @click="editHandler"
            >{{ this.$t('CargoMsg.Cargo_Edit') }}
            </el-button>
            <el-button
              type="danger"
              @click="deleteHandler"
            >{{ this.$t('CargoMsg.Cargo_OrderDelete') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="25000619"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="25000620"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
      <div v-show="['edit', 'add'].includes(action)" class="main-content rule-config-page">
        <el-form
          label-position="left"
          label-width="70px"
        >
          <div style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_RuleRole')">
              <el-select v-model="form.commissionRole" style="width: 200px;padding-right: 5px" filterable clearable @change="commissionRoleChange(true)">
                <el-option
                  v-for="(item,index) in SystemConstants.COMMISSION_ROLE_LIST"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ApplicablePersonnel')">
              <div style="display: flex;padding-left: 5px">
                <cargo-advance-select
                  no="commissionPersonnel"
                  :multiple="true"
                  filterable
                  :default-multiple-value="form.commissionPersonnelList"
                  tag-value="uuid"
                  tag-name="chineseName"
                  :filter-tag-names="['chineseName']"
                  :cache="false"
                  :static-options="officeRoleUser"
                  :placeholder="' '"
                  style="width: 240px;"
                  @parentCallBack="p=>{form.commissionPersonnelList=p.value;}"
                />
                <el-button type="primary" no="showRole" style="margin-left: 5px;" @click="showRoleDialog"> {{ '...' }} </el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ApplicableScript')" style="padding-left: 5px">
              <cargo-advance-select
                no="applicableScriptUuid"
                :multiple="true"
                filterable
                :default-multiple-value="form.applicableScriptUuidList"
                tag-value="uuid"
                tag-name="scriptName"
                :filter-tag-names="['scriptName']"
                :cache="false"
                :static-options="ruleConfigs"
                :placeholder="' '"
                style="width: 240px;"
                @parentCallBack="p=>{form.applicableScriptUuidList=p.value;}"
              />
            </el-form-item>
          </div>
        </el-form>

        <div style=" display: flex; align-items: center;justify-content: center;">
          <div style="margin-bottom: 20px; margin-top: 20px">
            <div style="display: inline-block">
              <el-button type="primary" no="testRun" style="margin-left: 5px;" @click="testRunHandler"> {{ $t('CargoMsg.Cargo_TestRun') }} </el-button>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="25000701"
            :grid-params.sync="edit.gridParams"
            :grid-options="edit.gridOptions"
            :column-defs="edit.columnDefs"
            :row-data="edit.rowData"
            @gridReady="params=>edit.gridApi=params.api"
          />
        </div>
        <div style=" display: flex; align-items: center;justify-content: center;">
          <div style="margin-bottom: 20px; margin-top: 20px">
            <div style="display: inline-block">
              <el-button type="primary" no="1" style="margin-left: 5px;" @click="saveHandler"> {{ $t('CargoMsg.Cargo_Save') }} </el-button>
              <el-button type="primary" no="1" style="margin-left: 5px;" @click="cancelHandler()"> {{ $t('CargoMsg.Cargo_Cancel') }} </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    查看关联业务-->
    <show-job-dialog
      v-if="showJobDialog.visible"
      ref="showJobDialog"
      :visible.sync="showJobDialog.visible"
      :jobs="showJobDialog.jobs"
      @close="showJobDialog.visible = false"
    />

    <!-- 分公司下有权限的部门角色用户   -->
    <branch-role-select-dialog
      v-if="branchRoleSelectDialog.visible"
      ref="branchRoleSelectDialog"
      :visible.sync="branchRoleSelectDialog.visible"
      :value="branchRoleSelectDialog.value"
      :row-data="branchRoleSelectDialog.rowData"
      @callback="selectDialogHandler"
    />
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  advancedQuery,
  advancedQueryApplicationFunc,
  deleteApplicationFunc,
  saveApplicationFunc
} from '@/api/ruleConfig/ruleConfigAi'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { roleUserDataFunc } from '@/api/office'
import BranchRoleSelectDialog from '@/views/cargo/v0/Performance/tabPane/BranchRoleSelectDialog.vue'
import $store from '@/store'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { DocumentManage } from '@/utils/commonUtil'
import { queryJobDataByUuidsFunc, testRunFunc } from '@/api/ruleConfig/provisionReport'
import ShowJobDialog from '@/views/cargo/v0/Performance/tabPane/showJobDialog.vue'
import { OPERATOR_LIKE } from '@/class/cargo/model/utils/AdvancedSearchConsts'

export default {
  name: 'RuleApplication',
  components: {
    ShowJobDialog,
    BranchRoleSelectDialog,
    cargoAdvanceSelect,
    searchItem
  },
  data() {
    return {
      URL,
      isAdvancedQuery: true, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      action: 'list',
      customSearchItems: [],
      form: {
        uuid: '',
        version: 1,
        commissionRole: '',
        commissionPersonnel: '',
        applicableScriptUuid: '',
        commissionPersonnelList: [],
        applicableScriptUuidList: []
      },
      branchRoleSelectDialog: {
        visible: false,
        rowData: [],
        value: []
      },
      showJobDialog: {
        visible: false,
        jobs: []
      },
      filterJson: {},
      officeTree: [],
      officeRoleUser: [],
      selectData: null,
      editSelectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionRole'),
          colId: 'commissionRole',
          field: 'commissionRole',
          width: 150,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(SystemConstants.COMMISSION_ROLE_LIST, params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionPersonnel'),
          colId: 'commissionPersonnel',
          field: 'commissionPersonnel',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.commissionPersonnelList) {
              const nameList = []
              for (const data of params.data.commissionPersonnelList) {
                nameList.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'uuid', data, 'chineseName'))
              }
              return nameList.join(',')
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data.commissionPersonnelList) {
              const nameList = []
              for (const data of params.data.commissionPersonnelList) {
                nameList.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'uuid', data, 'chineseName'))
              }
              return nameList.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableScript'),
          colId: 'applicableScriptUuid',
          field: 'applicableScriptUuid',
          width: 150,
          cellRenderer: (params) => {
            if (this.ruleConfigs && this.ruleConfigs.length > 0 && params.data.applicableScriptUuidList) {
              const nameList = []
              for (const data of params.data.applicableScriptUuidList) {
                const ruleC = this.ruleConfigs.filter(p => p.uuid === data)
                if (ruleC && ruleC.length > 0) {
                  nameList.push(ruleC[0].scriptName)
                }
              }
              return nameList.join(',')
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (this.ruleConfigs && this.ruleConfigs.length > 0 && params.data.applicableScriptUuidList) {
              const nameList = []
              for (const data of params.data.applicableScriptUuidList) {
                const ruleC = this.ruleConfigs.filter(p => p.uuid === data)
                if (ruleC && ruleC.length > 0) {
                  nameList.push(ruleC[0].scriptName)
                }
              }
              return nameList.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'),
          colId: 'dateModified',
          field: 'dateModified',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      ruleConfigs: [],
      documentManage: new DocumentManage(),
      edit: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 选中
          onRowClicked: (event) => {
            this.editSelectData = event.data
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            if (this.edit.gridOptions.api && event.column) {
              this.edit.gridOptions.api.forEachNode(node => {
                if (node.rowIndex === event.rowIndex) {
                  this.editSelectData = node.data
                }
              })
            }
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: '',
            width: 55,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Message.Name2'),
            colId: 'userId',
            field: 'userId',
            width: 150,
            valueFormatter: (params) => {
              if (!params.value) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RuleRole'),
            colId: 'commissionRole',
            field: 'commissionRole',
            width: 150,
            cellRenderer: (params) => {
              return CommonState.getNameByCode(SystemConstants.COMMISSION_ROLE_LIST, params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_BusinessVolume'),
            colId: 'businessNum',
            field: 'businessNum',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableRule'),
            colId: 'applicableScriptUuid',
            field: 'applicableScriptUuid',
            width: 150,
            cellRenderer: (params) => {
              if (this.ruleConfigs && this.ruleConfigs.length > 0 && params.data.applicableScriptUuid) {
                const ruleC = this.ruleConfigs.filter(p => p.uuid === params.data.applicableScriptUuid)
                if (ruleC && ruleC.length > 0) {
                  return ruleC[0].scriptName
                }
              }
              return ''
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CommissionAmount'),
            colId: 'commissionAmount',
            field: 'commissionAmount',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ViewDetailedBusiness'),
            colId: 'dateCreated',
            field: 'dateCreated',
            width: 150,
            cellRenderer: params => {
              if (params.data.businessNum) {
                const onViewDetailedBusiness = this.documentManage.getPath('onViewDetailedBusiness')
                return `<button><div onclick="${onViewDetailedBusiness}('${params.data.jobs}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div></button>`
              } else {
                return ''
              }
            }
          }
        ],
        rowData: []
      }
    }
  },
  computed: {},
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init(true)
    }
  },
  beforeMount() {
    this.init(true)
    const context = this
    this.documentManage.set('onViewDetailedBusiness', function(value) {
      context.onViewDetailedBusiness(value)
    })
  },
  methods: {
    async init(init = false) {
      this.ruleConfigs = []
      const from = {}
      from.branchId = this.$store.getters.currentOfficeId
      advancedQuery(from).then(res => {
        this.ruleConfigs = res.data.list
        if (this.ruleConfigs) {
          for (const data of this.ruleConfigs) {
            data.chineseName = data.scriptName
            data.code = data.uuid
          }
        }
        if (init) {
          // 初始化 静态高级查询
          this.initCustomSearchItems()
        }
      })
    },
    toQuery() {
      this.toAdvancedQuery()
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      let searchField = new AdvancedSearchField()
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 0
      searchField.itemCondition = [OPERATOR_LIKE]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'm.APPLICABLE_SCRIPT_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_ApplicableScript'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = this.ruleConfigs
      defaultSearchFields.push(searchField.formatObj2Json())
      this.customSearchItems = defaultSearchFields
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = [... data]
        this.filter.pageNum = 1
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryApplicationFunc(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 新增
    addHandler() {
      this.clear()
      this.action = 'add'
    },
    // 编辑
    editHandler() {
      if (!this.selectData || !this.selectData.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.action = 'edit'
      this.clear()
      this.form = { ...this.selectData }
      this.commissionRoleChange(false)
    },
    // 删除
    deleteHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.ConfirmDeleteN', [rows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading4Cxt()
        const data = {
          keys: Array.from(rows, p => p.uuid)
        }
        deleteApplicationFunc(data).then(res => {
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      }).catch(() => { })
    },
    testRunHandler() {
      if (!this.form.commissionPersonnelList || this.form.commissionPersonnelList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ApplicablePersonnel'))
        return
      }
      this.fullscreenLoading = getLoading4Cxt()
      const data = {
        branchId: $store.getters.currentOfficeId,
        commissionRole: this.form.commissionRole,
        applicableScriptUuidList: this.form.applicableScriptUuidList,
        commissionPersonnelList: this.form.commissionPersonnelList
      }
      testRunFunc(data).then(res => {
        this.edit.rowData = res.data
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    saveHandler() {
      this.fullscreenLoading = getLoading4Cxt()
      this.form.branchId = $store.getters.currentOfficeId
      saveApplicationFunc(this.form).then(res => {
        this.cancelHandler()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 提成角色变动
    async commissionRoleChange(clear = false) {
      if (!this.form.commissionRole) {
        this.officeRoleUser = []
        this.form.commissionPersonnelList = []
        return
      }
      this.fullscreenLoading = getLoading4Cxt()
      const form = {
        branchId: this.$store.getters.currentOfficeId,
        anyStr: this.form.commissionRole
      }
      if (clear) {
        this.form.commissionPersonnelList = []
      }
      await roleUserDataFunc(form).then(res => {
        this.officeTree = res.data
        this.officeRoleUser = []
        for (const ot of this.officeTree) {
          if (ot.type === 4) {
            const d = this.officeRoleUser.find(p => ot.uuid === p.uuid)
            if (!d || !d.uuid) {
              this.officeRoleUser.push(ot)
            }
          }
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    showRoleDialog() {
      this.branchRoleSelectDialog.value = this.form.commissionPersonnelList
      this.branchRoleSelectDialog.rowData = this.officeTree
      this.branchRoleSelectDialog.visible = true
    },
    selectDialogHandler(e) {
      this.form.commissionPersonnelList = e
    },
    clear() {
      this.officeRoleUser = []
      this.form.uuid = ''
      this.form.version = 1
      this.form.commissionPersonnel = ''
      this.form.applicableScriptUuid = ''
      this.form.commissionRole = ''
      this.form.commissionPersonnelList = []
      this.form.applicableScriptUuidList = []
      this.edit.rowData = []
    },
    onViewDetailedBusiness(jobs) {
      if (jobs && jobs.length !== 0) {
        const uuids = jobs.split(',')
        queryJobDataByUuidsFunc({ branchId: $store.getters.currentOfficeId, keys: uuids }).then(res => {
          this.showJobDialog.jobs = res.data
          this.showJobDialog.visible = true
        })
      }
    },
    cancelHandler() {
      this.action = 'list'
      this.toQuery()
    }
  }
}
</script>
<style lang="scss">
.rule-config-page {
  padding-top: 20px;
  padding-left: 10px;
  background-color: white;

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 90%;
    }
  }

  .input-border {
    height: 100%;
    .el-textarea__inner{
      width: 100%;
      height: 100%;
    }
  }
}

</style>
